import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ShareBasedRemunerationForm, {
  ShareBasedRemunerationFormRef,
  ShareBasedRemunerationFormValues,
} from './ShareBasedRemunerationForm';

type CreateShareBasedRemunerationProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: ShareBasedRemunerationFormValues) => Promise<void>;
};

const CreateShareBasedRemunerationModal: React.FC<
  CreateShareBasedRemunerationProps
> = ({ isOpen, toggle, onSubmit }: CreateShareBasedRemunerationProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<ShareBasedRemunerationFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ShareBasedRemunerationFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.addNewShareBasedRemuneration']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <ShareBasedRemunerationForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateShareBasedRemunerationModal;
